import * as React from "react"

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Button from '@material-ui/core/Button';
import { withStyles, Theme, WithStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import DialogActions from '@material-ui/core/DialogActions';

import { Trans, WithTranslation, withTranslation } from 'react-i18next';
import { BrowserRouter, Route, Link } from 'react-router-dom';

// import CONFIG from '../../cfg/config';

const odstep: string = '          ';

class Notifier extends React.Component<WithTranslation & WithStyles<typeof styles>, any> {

  // componentDidMount() {
  //   this.sendSuccess()
  // }

  // async sendSuccess() {
  //   try {
  //     let res: ReservationId = await bookService.reservConfirm(
  //       {
  //         hotelId: CONFIG.hotelID, 
  //         aOperatorId: Number(sessionStorage.getItem("operator_id")),
  //         aPobytId: 123
  //        }, {})    
  //   } catch (error) {
  //     console.error
  //   } 
  //  }

  //PM 2021-08-17
  //usuniecie disableBackdropClick
  render() {
    const classes = this.props.classes;

    return (
      <Dialog
        disableEscapeKeyDown
        maxWidth="xs"
        open={true}
      >
        <DialogTitle disableTypography>
          <Typography variant="h6" component="h2"
            className={classes.lowercase}
            style={{ color: '#458B00' }}>
            <b><Trans>Success</Trans></b>
          </Typography>
          <hr className={classes.hr} />
        </DialogTitle>
        <DialogContent>
          <DialogContentText /*className={classes.dialogContentText}*/>
            <Trans>The internet transaction was successful</Trans>
          </DialogContentText>
          <DialogContentText className={classes.dialogContentText}>
            <Trans>Click OK to go to the main page</Trans>{odstep}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" size="small" component={Link} to="/"
            style={{ color: '#458B00' }}>
            <b>ok</b>
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const styles = (theme: Theme) => ({
  dialogContentText: {
    whiteSpace: 'pre' as 'pre'
  },
  hr: {
    marginTop: '10px'
  },
  lowercase: {
    textTransform: "lowercase" as "lowercase"
  }
});

export default withTranslation()(withStyles(styles)(Notifier));